import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  comprasDiretasItens: []
});

function ComprasDiretaReducer(state = initialState, action) {
  switch (action.type) {
    case types.COMPRAS_DIRETA_ITENS_START: {
      return startLoad(state);
    }

    case types.COMPRAS_DIRETA_ITENS_ERROR: {
      return endLoad(state);
    }

    case types.COMPRAS_DIRETA_ITENS_SUCCESS: {
      return endLoad(state.set('comprasDiretasItens', fromJS(action.payload)));
    }
  }

  return state;
}

export default ComprasDiretaReducer;
